import {defineSlotRecipe} from '@chakra-ui/react3'

export const materialVariationSelectionRecipe = defineSlotRecipe({
    slots: ['root', 'label', 'selectedValue', 'chips'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: 'spacing-8'
        },
        label: {
            display: 'flex',
            gap: 'spacing-10',
            textStyle: 'heading.small',
            color: 'text.primary'
        },
        selectedValue: {
            color: 'text.tertiary'
        },
        chips: {
            display: 'flex',
            gap: 'spacing-10',
            // on narrow viewports too many selectors scroll horizontally instead of stacking
            // into several rows; from `s` up the cockpit column has room to wrap
            flexWrap: {base: 'nowrap', s: 'wrap'},
            overflowX: {base: 'auto', s: 'visible'}
        }
    }
})

export default materialVariationSelectionRecipe
